$(function() {

    function setActiveById(id)
    {
        $(".bottom-block div").removeClass("active");
        $(".bottom-block div[data-map='"+id+"']").addClass("active");

        $(".block-wrap").removeClass("toggled");
        $("#"+id).addClass("toggled");

        $(".help-text div").removeClass("active");
        $(".help-text div[data-map='"+id+"']").addClass("active");

        if(id=="l-register" || id=="l-forgot") {
            $(".login-content").addClass("active-help");
        }else{
            $(".login-content").removeClass("active-help");
        }
    }

    $(".authAutoLink").on("click",function(){
        var id=$(this).attr("data-id");
        setActiveById(id);
        return false;
    });
});